import type { SVGProps } from "react";

export const BackwardsDirectionArrow = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.1665 2.5V7.5C4.1665 7.95833 4.3297 8.35069 4.65609 8.67708C4.98248 9.00347 5.37484 9.16667 5.83317 9.16667H12.4998V14.3333L11.1665 13L9.99984 14.1667L13.3332 17.5L16.6665 14.1667L15.4998 13L14.1665 14.3333V9.16667C14.1665 8.70833 14.0033 8.31597 13.6769 7.98958C13.3505 7.66319 12.9582 7.5 12.4998 7.5H5.83317V2.5H4.1665Z"
        fill="#C5C6C9"
      />
    </svg>
  );
};
